import { createContext, useContext, useState, useEffect, useCallback } from "react";
import axios from "axios";

const MemberAuthContext = createContext(null);
const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

let _memberToken = null;
try { _memberToken = localStorage.getItem("member_token"); } catch {}

function saveToken(tok) {
  _memberToken = tok || null;
  try {
    if (tok) localStorage.setItem("member_token", tok);
    else localStorage.removeItem("member_token");
  } catch {}
}

const memberApi = axios.create({ baseURL: API });
memberApi.interceptors.request.use((config) => {
  if (_memberToken) config.headers.Authorization = `Bearer ${_memberToken}`;
  return config;
});

export function MemberAuthProvider({ children }) {
  const [member, setMember] = useState(null);
  const [loading, setLoading] = useState(true);

  const refresh = useCallback(async () => {
    if (!_memberToken) { setMember(null); setLoading(false); return; }
    try {
      const { data } = await memberApi.get("/member/me");
      setMember(data);
    } catch {
      saveToken(null);
      setMember(null);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => { refresh(); }, [refresh]);

  const register = async (payload) => {
    const { data } = await memberApi.post("/member/register", payload);
    saveToken(data.token);
    setMember(data.member);
    return data;
  };

  const login = async (email, password) => {
    const { data } = await memberApi.post("/member/login", { email, password });
    saveToken(data.token);
    setMember(data.member);
    return data;
  };

  const logout = () => { saveToken(null); setMember(null); };

  return (
    <MemberAuthContext.Provider value={{ member, loading, register, login, logout, refresh, memberApi }}>
      {children}
    </MemberAuthContext.Provider>
  );
}

export function useMember() {
  const ctx = useContext(MemberAuthContext);
  if (!ctx) throw new Error("useMember must be used within MemberAuthProvider");
  return ctx;
}

export { memberApi };
